module.exports = require("lodash/camelCase");